import { connect } from 'react-redux';
import UserAdmin from './UserAdmin';
import {
  getUsersList,
  getRolesOnUser,
  getRolesList,
  addRoleOnUser,
  addRoleOnUserClear,
  deleteRoleOnUser,
  deleteRoleOnUserClear,
  createOrUpdateUserClear,
  createOrUpdateUser,
  getVisitsUser,
  getVisitsUserClear
} from '../../../store/actions/admin';

const mapStateToProps = ({ adminReducer, userReducer }) => ({ adminReducer, userReducer });
const mapDispatchToProps = {
  getUsersList,
  getRolesOnUser,
  getRolesList,
  addRoleOnUser,
  addRoleOnUserClear,
  deleteRoleOnUser,
  deleteRoleOnUserClear,
  createOrUpdateUserClear,
  createOrUpdateUser,
  getVisitsUser,
  getVisitsUserClear
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAdmin);
